<header class="page-top default" style="background-image: url('/assets/images/page-top-bg.png');width: 100%; height: auto; overflow: -webkit-paged-x;">
  <div class="container-fluid transition2s">
  </div>
  <!-- /.container-fluid-->
  <div class="black-bg"></div>
  <div class="page-top-map">
    <div class="google-map gMap-holder"></div>
  </div>
  <div class="page-top-content" id="FreeDemo">
    <div>
      <!-- .container-->
      <div class="container padding-zero">
        <div class="text-center">
          <a routerLink="/account-home">
          <img src="assets/images/A4U_Logo_Thank_You.png" alt="Apply4u" title="Apply4u" class="img-desk wauto">
        </a>
        </div>
          <!-- .row-->
        <div class="row">
          <p class="text-center h1 w-color">Please Wait...</p>
          
          <!-- <p class="text-center" style="color:white"><a routerLink="/account-home" class="text-bold">Click Here</a> - If you are not re-directed in 10sec(s).</p>-->
          <span class="col-md-2"></span>
          <span class="col-md-8 text-center">
           
          </span>
        </div>
        <!-- /.row-->
      </div>
      <!-- /.container-->
    </div>
  </div>
 
</header>

 